/*
 * @Author: handan05
 * @Date: 2022-07-28 11:21:05
 * @LastEditors: handan05
 * @LastEditTime: 2022-10-09 17:20:15
 * @FilePath: /operation-utils/Users/handan/Documents/handan_work/58project/tech/wblog/src/platforms/index.ts
 * @Description:
 */
import pc from './pc';
import m from './m';
import ganji from './ganji';
import wuba from './wuba';
import zcm from './zcm';
import harmony from './harmony';
import miniProgram from './miniProgram';
const platform: any = {
    pc,
    m,
    ganji,
    wuba,
    wbutown: wuba,
    zcm,
    harmony,
    miniProgram
};

export default platform;
